'use client';

import { useMemo } from 'react';
import { WebViewScreen } from '@diritto/common/app/webview-header.constant';
import { TrackerPosition } from '@diritto/common/tracker/tracking-event.constant';
// import { SectionReplyList } from 'app-components/sections/ReplyList';
import { SectionReply } from '@/app-components/reply/SectionReply';
import { useGetContestRepliesQuery } from '@/queries/contests/useGetContestCommentsQuery';
import { MutableHeaderLayout } from 'ui-components/layout/MutableHeaderLayout';
import { useInAppHeader } from 'ui-hooks/useInAppHeader';
import { useInAppStatusBar } from 'ui-hooks/useInAppStatusBar';

type ContentPageProps = {
  isApp?: boolean;
  contestId: number;
};

export const SectionPage = ({ isApp, contestId }: ContentPageProps) => {
  useInAppHeader({ screen: WebViewScreen.Section, title: '실시간 댓글' });
  useInAppStatusBar(WebViewScreen.Section);

  return (
    <MutableHeaderLayout title={'실시간 댓글'} isApp={isApp}>
      <SectionReplyList contestId={contestId} />
    </MutableHeaderLayout>
  );
};

export const SectionReplyList = ({ contestId }: { contestId: number }) => {
  const { data } = useGetContestRepliesQuery(contestId);

  const { replies, profileLites, contents, episodes } = useMemo(
    () => ({
      replies: data?.replies ?? [],
      contents: data?.contents ?? {},
      episodes: data?.episodes ?? {},
      profileLites: data?.profileLites ?? {},
    }),
    [data],
  );

  return (
    <div className="flex flex-col gap-4 p-4">
      {replies.map(reply => {
        if (reply.isDeleted) {
          return null;
        }

        return (
          <SectionReply
            key={reply.id}
            reply={reply}
            contents={contents}
            episodes={episodes}
            profileLites={profileLites}
            className="h-[180px]"
            trackerExtraInfo={{
              trackerPosition: TrackerPosition.SectionDetail,
            }}
            descriptionLineCount={2}
          />
        );
      })}
    </div>
  );
};
